/** @format */

import {endOfDay, isPast, parseISO} from 'date-fns';

import {getDaysLeft} from 'features/tariffs/helpers/getDaysLeft';

const WARN_BEFORE_IN_DAYS = 10;

interface Subscription {
  beginDate?: string | null;
  endDate?: string | null;
  activeSubscription: boolean;
  planId?: number | null;
}

export const payNow = <S extends Subscription>(subscription: S) => {
  // No subscription
  if (!subscription.beginDate || !subscription.endDate) return true;
  if (!subscription.activeSubscription) return true;

  const endDate = parseISO(subscription.endDate);
  // Subscription already expired
  return isPast(endOfDay(endDate));
};

interface SubscriptionWithEndDate {
  endDate?: string | null;
}

export const paySoon = <S extends SubscriptionWithEndDate>(subscription: S) => {
  // No subscription
  if (!subscription.endDate) return false;

  const endDate = parseISO(subscription.endDate);
  // Subscription already expired
  if (isPast(endOfDay(endDate))) return false;

  // Subscription expiring soon
  return daysLeft(subscription) <= WARN_BEFORE_IN_DAYS;
};

export const daysLeft = <S extends SubscriptionWithEndDate>(subscription: S) => {
  if (!subscription.endDate) return 0;
  const endDate = parseISO(subscription.endDate);
  if (isPast(endOfDay(endDate))) return 0;

  return getDaysLeft(endDate);
};
